import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useCommonQueryKey } from './useCommonQueryKey'

export const useInvalidateCommonQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useCommonQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
